/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-19 14:30:13
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-23 09:07:19
 */
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux';
import axios from 'axios'
import {message, Radio, Input, Avatar} from 'antd'
import Search from 'antd/lib/input/Search'
// ***********************************************************************************
// ****   ******   ********  *****************  ********   ****************   ********
// ****   **        *******  *********   *          ****   *         ******   ********
// *           ******              ****   ****  ********  **         ******   ********
// **   *      ******              *****            ***   ******    **               *
// ***  *  *   ******   ***  ***   ***********  *****        **   *********   ********
// *                *   ***  ***   **                **      **   ********   *********
// *           *  ***              ****  **************  *   **   ********         ***
// ****   **   *  ***   ***  ***   ****  **        ***   *           *****   ***  ****
// *           *  ***   ***  ***   ****  **  ****  ***      ***   *******     *   ****
// ****   **   *  ***              ****  **        ****     ***   ******      *   ****
// **          *  ***   ***  ***   ****      ****  *****    ***   *****    *     *****
// *           *  ***   ***  **********            ****      **   ****    ***    *****
// *          **  *********  *********    *  ****  ***   **  **   ***    **        ***
// ***    *   **  *********  **********  **  **    **   *****     ******     ****    *
// ***  ***  ***  *********  *******************  *********************** ************
// ***********************************************************************************
// const AddFriend = (props) => {
class AddFriend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            friendlist: [],
            selecteduser: null,
            canClick: true,
            searchFriend: "",
        }
        this.messagetextarea = null;
    }

    componentDidMount() {
        this.getuserList({target: {}});
    }

    componentDidUpdate(preProps) {
        if (preProps.user.userId !== this.props.user.userId) {
            this.getuserList({target: {}});
        }
    }

    setUserList = (value) => {
        this.setState({friendlist: value});
    }
    selectuser = (value) => {
        this.setState({selecteduser: value});
    }
    setCanClick = (value) => {
        this.setState({canClick: value});
    }

    onChange = (value) => {
        console.log("onChange", value);
        this.selectuser(value.target.data)
    }

    searchFriendList = ({target: {value}}) => {
        this.setState({searchFriend: value});
    }

    getuserList = ({target: {value}}) => {

        // this.setState({searchFriend:value})
        const {user} = this.props;
        axios.get(`${global.serviceUrl.chat}/friend/myfriendofall?userId=${user.userId}`)
            .then(res => {
                // console.log(res.data)
                let sendList = [...res.data.payload];
                sendList.map((data) => {
                    data.avatar = global.yunguanAvatar + '/'+data.avatar
                })
                this.setUserList(sendList)
                // this.selectuser(null)
            })
    };

    sendApp = async () => {
        const {selecteduser, canClick} = this.state;
        const {user} = this.props;
        this.setCanClick(false)
        if (canClick) {
            await axios.post(`${global.serviceUrl.chat}/apply/save`, {
                "applyType": "private",
                "userId": user.userId,
                "applyFor": selecteduser.userId,
                content: this.messagetextarea && this.messagetextarea.resizableTextArea.props.value,
                "source": "search"
            }).then(res => {
                console.log(res.data)
                switch (res.data.code) {
                    case '200':
                        message.success(res.data.message)
                        break;
                    case '500':
                        message.error(res.data.message)
                        break;
                }
                this.props.close()
                this.setCanClick(true)
            }).catch(e => {
                message.error('')
                this.props.close()
                this.setCanClick(true)
            })
        }
    }

    render() {
        const {friendlist, selecteduser} = this.state;
        const {user} = this.props;
        // console.log("selecteduser", friendlist, selecteduser, props, props.user);

        // console.log("检查key值报错：",friendlist.filter(friend => ['ZZX-gxfw000060','ZZX-gxfw000057','ZZX-gxfw000058','ZZX-gxfw000059'].includes(friend.userId)));
        return (
            <div className='chat-addfriend-panel'>
                <Search className='addgroup-search common-search'
                        // value={this.state.searchFriend}
                        // onChange={this.getuserList}
                        onChange={this.searchFriendList}
                        placeholder='搜索'></Search>
                <div className='chat-addfriend-list'>
                    <Radio.Group onChange={this.onChange} value={selecteduser && selecteduser.userId}>
                        {friendlist.map((user1, index) => {
                            // debugger
                            // console.log("检查key值报错：",friendlist)
                            if (user1.userName.includes(this.state.searchFriend)) {
                                // console.log("查询结果;", user1)

                                return (<div
                                        // key={user1.userId}
                                        key={index}
                                    >
                                        <Radio value={user1.userId} data={user1} className='chat-addfriend-entity'>
                                            {/* <input type="radio" className='chat-addfriend-entity-radio' /> */}
                                            <Avatar size={28} shape="square" src={user1.avatar}
                                                    className={'chat-addfriend-avatar'}></Avatar>
                                            <div className='chat-addfriend-entity-nametext'>
                                                {/*{user1.userName}*/}
                                                {user1.userName && user1.userName.split(this.state.searchFriend).map((text, index) => {
                                                    return (<span key={index}><span
                                                        style={{background: 'yellow'}}>{index !== 0 && this.state.searchFriend}</span><span>{text}</span></span>)
                                                })}
                                            </div>
                                        </Radio>
                                        <div className='chat-addfriend-entity-divider'></div>
                                    </div>
                                )
                            }
                        })}
                    </Radio.Group>
                </div>
                <div className='chat-addfriend-divider'></div>
                {
                    selecteduser &&
                    <div className='chat-addfriend-right'>
                        <div className='chat-addfriend-userinfo'>
                            <Avatar size={70} shape="square" src={selecteduser.avatar}
                                    className={'chat-addfriend-sendapp-avatar'}></Avatar>
                            <div className='chat-addfriend-userinfo-username'>
                                {selecteduser.userName}
                            </div>
                            <div className='chat-addfriend-userinfo-other'>
                                真名：未知
                            </div>
                            <div className='chat-addfriend-userinfo-other'>
                                电话：{selecteduser.phone}
                            </div>

                        </div>
                        <div className='chat-addfriend-sendmessage'>
                            <Input.TextArea ref={ref => {
                                this.messagetextarea = ref
                            }} maxLength='40'
                                            defaultValue={`你好!我是${user.userName}`}
                                            className='chat-addfriend-sendmessage-textarea' style={{height: 180}}>
                            </Input.TextArea>
                        </div>
                        <div className='chat-addfriend-add'
                             onClick={this.sendApp} style={{marginRight: 100}}
                        >   {'发送请求'}
                        </div>
                    </div>
                }
                <div className='chat-addfriend-bottom'>
                    <div className='chat-addfriend-cancel'
                         onClick={() => {
                             this.props.close()
                         }}
                    >   {'取消'}      </div>
                </div>
            </div>)
    }

}

// export default AddFriend
const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(AddFriend);
